/* global SOCKET_HOST */
import io from 'socket.io-client';
const socketConfig = require('../../config.json');
/*
var SOCKET_HOST =   `${socketConfig.SERVER_IP}` ;
if(socketConfig.SERVER_PORT !=  80){
    SOCKET_HOST =   `${socketConfig.SERVER_IP}:${socketConfig.SERVER_PORT}` ;
}*/
const socket = null;
export default socket; 